module.exports = __webpack_public_path__ + "img/logo-delivery.cd4ccbc0.svg";